/**
 * Composant EmptyState - Affichage d'un état vide réutilisable
 * Utilisé pour afficher un message quand il n'y a pas de données
 */
import React from 'react';
import PropTypes from 'prop-types';

const EmptyState = ({ message, icon = '📭', className = '' }) => {
  return (
    <div className={`text-center py-12 text-gray-500 ${className}`}>
      <div className="text-4xl mb-2" role="img" aria-label="Icône d'état vide">
        {icon}
      </div>
      <p className="text-base">{message}</p>
    </div>
  );
};

EmptyState.propTypes = {
  message: PropTypes.string.isRequired,
  icon: PropTypes.string,
  className: PropTypes.string
};

export default EmptyState;
